import { ghs } from './data/ghscode_10';
export function getHStatements() {
    return ghs.hStatements;
}
export function getHStatementsObject() {
    const result = {};
    ghs.hStatements.forEach((h) => {
        if (result[h.code]) {
            throw new Error(`This should never happen, duplice hCode: ${h.code}`);
        }
        result[h.code] = h;
    });
    return result;
}
export function getPStatements() {
    return ghs.pStatements;
}
export function getPStatementsObject() {
    const result = {};
    ghs.pStatements.forEach((p) => {
        if (result[p.code]) {
            throw new Error(`This should never happen, duplice code: ${p.code}`);
        }
        result[p.code] = p;
    });
    return result;
}
export function getGHS() {
    return ghs.pictograms;
}
export function getGHSObject() {
    const result = {};
    ghs.pictograms.forEach((g) => {
        if (result[g.code]) {
            throw new Error(`This should never happen, duplice code: ${g.code}`);
        }
        result[g.code] = g;
    });
    return result;
}
//# sourceMappingURL=index.js.map